import { ReactElement, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCircleFilled } from '@ant-design/icons';
import { EDGE_OPTIONS_INFO_IMAGE } from '@common/constants';
import { DrawingShape } from '@common/models';
import ConfigurableModal from '@core/components/modal/modal';
import SlabIcon from '@core/components/slab-icon/slab-icon';
import ImageUtils from '@core/utils/ImageUtils';
import { useSelectedColor } from '@ee-api/colors-api/useSelectedColor';
import { useSelectedMaterial } from '@ee-api/materials-api/useSelectedMaterial';
import { DrawingShapeContext } from '@ee-context';
import { useAppSelector } from '@redux/hooks';
import { selectClearedShapeEditNotifications } from '@redux/slices/drawingShapeSlice';

import { ShapeSideItems } from './components/ShapeSideItems/ShapeSideItems';

import './shapeTabContent.scss';

const ShapeTabContent = ({ shape }: { shape: DrawingShape }): ReactElement => {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const { selectedValue: selectedColor } = useSelectedColor();
    const { selectedValue: selectedMaterial } = useSelectedMaterial();

    const { activeDrawingShape } = useContext(DrawingShapeContext);
    const clearedShapeEditNotifications = useAppSelector(selectClearedShapeEditNotifications);
    const { t } = useTranslation();

    return (
        <div className="shape-content">
            <div className="shape-title-area">
                {selectedColor && selectedMaterial && (
                    <div className="text-area">
                        <SlabIcon src={ImageUtils.imgUrl(selectedColor.swatchImageUrl)} />
                        <div>
                            <div className="material-name">{selectedMaterial.description}</div>
                            <div>{selectedColor.name}</div>
                        </div>
                    </div>
                )}
                <InfoCircleFilled className="info-icon" onClick={() => setIsModalVisible(true)} />
            </div>
            <div className="shape-notification">
                {activeDrawingShape && !clearedShapeEditNotifications.includes(activeDrawingShape.id) ? (
                    t('SHAPE_TAB.NOTIFICATION')
                ) : (
                    <>&nbsp;</>
                )}
            </div>
            <div className="shape-side-area">
                <ShapeSideItems shape={shape} />
            </div>
            <ConfigurableModal
                isVisible={isModalVisible}
                onClose={setIsModalVisible}
                title={t('SCROLLABLE_AREA.COUNTERTOP.MODAL_DESCRIPTION')}
                content={<img className="modal-image" src={EDGE_OPTIONS_INFO_IMAGE} alt="countertop-options-preview" />}
                footer={null}
                isInfoModal
            />
        </div>
    );
};

export default ShapeTabContent;
